
// Training journal constants
export const SESSION_TYPES = [
  'Gi',
  'No-Gi',
  'Competition',
  'Wrestling',
  'Open Mat',
  'Private Lesson',
  'Seminar',
  'Other'
] as const;

export type SessionType = typeof SESSION_TYPES[number];

export const BELT_RANKS = [
  'white',
  'blue', 
  'purple',
  'brown',
  'black',
  'coral',
  'red'
] as const;

export const STRIPE_COUNTS = [
  'no stripes',
  '1',
  '2', 
  '3',
  '4'
] as const;

export const TRAINING_TYPES = [
  'bjj',
  'wrestling', 
  'judo',
  'mma'
] as const;

export const ROLL_TYPES = [
  'gi',
  'nogi',
  'both'
] as const;

export const INTENSITY_LEVELS = [
  'light',
  'moderate',
  'hard', 
  'competition'
] as const;
